import { Button } from '@cmg/design-system';
import React from 'react';

import { useDialogState } from '../../../../../../../../common/hooks/useDialogState';
import useCheckInstitutionalDuplicateAccess from '../../../../../../../../common/util/check-access/useCheckInstitutionalDuplicateAccess';
import { useIndicationActivitySyndicateContext } from '../../../../context/IndicationActivitySyndicateContext';
import UnmarkDuplicateConfirmDialog from '../../syndicate/indication-section-read-view/unmark-duplicate-confirm-dialog/UnmarkDuplicateConfirmDialog';

const UnmarkDuplicateButton: React.FC = () => {
  const { offeringId, basicPublishedOffering } = useIndicationActivitySyndicateContext();
  const indication = basicPublishedOffering!.orderBook.institutionalIndication!;
  const { canManageDuplicate } = useCheckInstitutionalDuplicateAccess({ offeringId });

  const {
    isOpen: isUnmarkDuplicateDialogOpen,
    onOpen: openUnmarkDuplicateDialog,
    onClose: closeUnmarkDuplicateDialog,
  } = useDialogState();

  if (!canManageDuplicate) {
    return null;
  }

  return (
    <React.Fragment>
      <Button key="unmark-duplicate" onClick={openUnmarkDuplicateDialog} variant="outlined">
        Unmark Duplicate
      </Button>
      <UnmarkDuplicateConfirmDialog
        isOpen={isUnmarkDuplicateDialogOpen}
        onClose={closeUnmarkDuplicateDialog}
        offeringId={offeringId}
        indicationId={indication.id}
        duplicateIndicationId={indication.duplicateOfIndicationId!}
      />
    </React.Fragment>
  );
};

export default UnmarkDuplicateButton;
